<template>
  <component
    v-model="showModal"
    :is="isModal ? 'BaseModal' : 'Fragment'"
    :size="isModal ? 'lg' : undefined"
    :title="title"
    @hide="onModalHide"
  >
    <template v-if="previewItem && isModal" #title>
      <div class="d-flex align-items-center" style="gap: 8px;">
        <span>{{ title }}</span>
        <BDXPreviewPopover
          :item="previewItem"
          :fetch-fn="fetchPreviewData"
          :columns="MATCH_PREVIEW_COLUMNS"
        />
      </div>
    </template>
    <slot />
  </component>
</template>

<script>
import Vue from 'vue'
import { defineComponent, inject } from '@vue/composition-api'
import { Fragment } from 'vue-fragment'

import { extractBdxRows } from '@util'
import { LincolnNewGlobalUMRService } from '@services'
import { BaseModal } from '@components/base'
import BDXPreviewPopover from '../BDXPreviewPopover.vue'

import { BDXEditFormInjectionKey } from './BDXEditForm.constants'

const MATCH_PREVIEW_COLUMNS = [
  { key: 'TPA_Name',                    label: 'TPA' },
  { key: 'Coverholder_Name',            label: 'Coverholder' },
  { key: 'Unique_Market_Reference_UMR', label: 'UMR' },
  { key: 'Risk_Code',                   label: 'Risk Code' },
  { key: 'Lloyds_Cat_Code',             label: 'Cat Code' },
  { key: 'Section_No',                  label: 'Section #' },
  { key: 'Settlement_Currency',         label: 'Settlement Currency' },
  { key: 'Year_of_Account',             label: 'YOA' },
  { key: 'Binder_Contract_Inception',   label: 'Binder Inception' }
]

export default defineComponent({
  name: 'BDXEditFormWrapper',
  components: {
    Fragment,
    BaseModal,
    BDXPreviewPopover
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    previewItem: { type: Object, default: null }
  },
  setup() {
    const { isModal, showModal, handleHideModal, hasChanges } = inject(
      BDXEditFormInjectionKey
    )

    const onModalHide = (evt) => {
      if (!isModal) return

      const trigger = evt.trigger

      if (hasChanges.value && trigger && trigger != 'ok') {
        evt.preventDefault()

        Vue.prototype.$swal({
          title: 'Confirmation',
          text: 'You have unsaved changes. Are you sure you want to close this window? Any unsaved changes will be lost.',
          type: 'warning',
          confirmButtonText: 'Okay',
          preConfirm: async (isConfirmed) => {
            if (!isConfirmed) return

            handleHideModal()
          }
        })
      }
    }

    const fetchPreviewData = async (item) => {
      if (!item || !item.umr_rc_cc_sn) return []
      const response = await LincolnNewGlobalUMRService.getBdxDataRows({
        umr_rc_cc_sn: item.umr_rc_cc_sn
      })
      return extractBdxRows(response.data)
    }

    return {
      isModal,
      showModal,
      onModalHide,
      MATCH_PREVIEW_COLUMNS,
      fetchPreviewData
    }
  }
})
</script>
